import axios from '@axios'

export default {
  namespaced: true,
  state: {
    data: [],
    item: null
  },
  getters: {},
  mutations: {
    SET_DATA(state, data) {
      state.data = data
    },
    SET_ITEM(state, item) {
      state.item = item
    },
    ADD_ITEM(state, item) {
      state.data.push(item)
    },
    EDIT_ITEM(state, item) {
      const index = state.data.findIndex(m => m._id === item._id)
      if (index >= 0) {
        Object.assign(state.data[index], item)
      }
    },
    REMOVE_ITEM(state, id) {
      const index = state.data.findIndex(m => m._id === id)
      if (index >= 0) {
        state.data.splice(index, 1)
      }
    },
  },
  actions: {
    getItems ({commit}) {
      return new Promise((resolve, reject) => {
        axios.get(`configuration`)
          .then(response => {
            commit("SET_DATA", response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getItem ({commit}, menu) {
      return new Promise((resolve, reject) => {
        axios.get(`configuration/${menu}`)
          .then(response => {
            commit("SET_ITEM", response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    addItem ({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`configuration`, payload)
          .then(response => {
            commit("ADD_ITEM", response.data.item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    editItem ({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`configuration/${payload._id}`, payload)
          .then(response => {
            commit("EDIT_ITEM", response.data.item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    deleteItem ({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`configuration/${id}`)
          .then(response => {
            commit("REMOVE_ITEM", id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  }
}
